import { recordEventGTM } from "../../lib/gtm";
import {
    ANALYTICS_PLAN_VIEW_EVENT_NAME,
    ANALYTICS_PLAN_VIEW_PROPERTIES_KEY,
    ANALYTICS_PLAN_SAVE_EVENT_NAME,
    ANALYTICS_PLAN_SAVE_PROPERTIES_KEY,
} from "@src/settings";

export function recordPlanView(
    id: number,
    name: string,
    slug: string,
    plan_identifier: string,
    house_type: string,
    bedrooms: number,
    bathrooms: number,
    cost: number,
    show_calculated_cost: boolean,
    minimum_plot_size: string
) {
    const planDetail = {
        id,
        name,
        slug,
        plan_identifier,
        house_type,
        bedrooms,
        bathrooms,
        cost,
        show_calculated_cost,
        minimum_plot_size,
    };

    process.env.NODE_ENV === "development" &&
        console.log(
            ANALYTICS_PLAN_VIEW_EVENT_NAME,
            ANALYTICS_PLAN_VIEW_PROPERTIES_KEY,
            planDetail
        );

    return recordEventGTM(
        ANALYTICS_PLAN_VIEW_EVENT_NAME,
        ANALYTICS_PLAN_VIEW_PROPERTIES_KEY,
        planDetail
    );
}

export function recordPlanSave(
    id: number,
    name: string,
    slug: string,
    plan_identifier: string,
    house_type: string,
    bedrooms: number,
    bathrooms: number,
    cost: number,
    show_calculated_cost: boolean,
    minimum_plot_size: string
) {
    const planDetail = {
        id,
        name,
        slug,
        plan_identifier,
        house_type,
        bedrooms,
        bathrooms,
        cost,
        show_calculated_cost,
        minimum_plot_size,
    };

    process.env.NODE_ENV === "development" &&
        console.log(
            ANALYTICS_PLAN_SAVE_EVENT_NAME,
            ANALYTICS_PLAN_SAVE_PROPERTIES_KEY,
            planDetail
        );

    return recordEventGTM(
        ANALYTICS_PLAN_SAVE_EVENT_NAME,
        ANALYTICS_PLAN_SAVE_PROPERTIES_KEY,
        planDetail
    );
}

/*
Plan detail

{
    "id": 154,
    "images": [
        {
            "id": 267,
            "image": {
                "id": 869,
                "title": "Rear Image",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/42111_Rear.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=b4b2ed2d60576d7290a593864f3957a2571a60f2814e71632cdeab286e82cbf5",
                "width": 2000,
                "height": 1250,
                "created_at": "2021-01-12T14:37:04.567265+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 3054187,
                "file_hash": "64c9e29f5bf8f827ae226fb1267a1e9d4ec94179",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 0,
            "building_plan": 154
        },
    ],
    "product": {
        "url": "http://api.inuua.net/oscar_api/products/132/",
        "upc": "building-plan-154",
        "id": 132,
        "title": "4 Bedroom  Maisonette- ID 42111",
        "description": "",
        "structure": "standalone",
        "date_created": "2021-01-12T14:46:35.210485+03:00",
        "date_updated": "2021-01-20T11:55:49.930856+03:00",
        "recommended_products": [],
        "attributes": [],
        "categories": [],
        "product_class": "building-plans",
        "images": [],
        "price": "http://api.inuua.net/oscar_api/products/132/price/",
        "availability": "http://api.inuua.net/oscar_api/products/132/availability/",
        "stockrecords": "http://api.inuua.net/oscar_api/products/132/stockrecords/",
        "options": [],
        "children": []
    },
    "floor_plans": [
        {
            "id": 172,
            "image": {
                "id": 871,
                "title": "Ground floor",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/groundfloor.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=e1335c193ed32a7954dd86e980af83e9874914d2fb68c54e78b59a4a66804e25",
                "width": 2100,
                "height": 1500,
                "created_at": "2021-01-14T21:04:35.382663+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 534250,
                "file_hash": "27eec2efbd80f488b9066e514a04e585a22570ef",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 0,
            "name": "Ground floor",
            "building_plan": 154
        },
        {
            "id": 173,
            "image": {
                "id": 872,
                "title": "First floor",
                "file": "https://inuua-prod.s3.amazonaws.com/original_images/first_floor.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXURR2KJDSDNH7JF6%2F20210615%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210615T093428Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=65c4834d440eb16955819cbdf160d57c780eb575207fb5f6b85c4a72c1518ade",
                "width": 2100,
                "height": 1500,
                "created_at": "2021-01-14T21:23:41.333438+03:00",
                "focal_point_x": null,
                "focal_point_y": null,
                "focal_point_width": null,
                "focal_point_height": null,
                "file_size": 313625,
                "file_hash": "68d6e0419a356c3a40e7a4bb04d07101885fe438",
                "collection": 1,
                "uploaded_by_user": 510
            },
            "sort_order": 1,
            "name": "First floor",
            "building_plan": 154
        }
    ],
    "stages": [
        {
            "id": 1451,
            "stage_name": "Excavations",
            "sort_order": 0,
            "phase": null,
            "material_cost": "0.00",
            "labour_cost": "18000.00",
            "short_description": "",
            "notes": "",
            "duration": "6.0",
            "materials": "[]",
            "labour": "[{\"type\": \"item\", \"value\": {\"name\": \"Excavations\", \"components\": [{\"labourer_type\": \"Casuals\", \"number_of_labourers\": 5, \"num_days\": 6, \"rate\": 600}]}, \"id\": \"41dc480c-984a-46e8-af58-892b3a5cf04a\"}]",
            "documents": "[]",
            "building_plan": 154,
            "descriptor": 21,
            "parent": null,
            "image": null
        }
    ],
    "name": "4 Bedroom  Maisonette- ID 42111",
    "slug": "4-bedroom-maisonette-id-42111",
    "plan_identifier": "42111",
    "is_public": true,
    "date_created": "2021-01-12T14:46:35.133033+03:00",
    "description": "<p>This a 4 bedroom all ensuite maisonette, suited to a 30 x 60 plot. The dining room has purposely been kept separate from the living area but it can be combined, and the various terraces allow for some expansion of rooms if required.</p>",
    "house_type": "maisonette",
    "bedrooms": 4,
    "bathrooms": 4,
    "floor_area": 158.0,
    "plot_area": 1.0,
    "width": "30.00",
    "length": "60.00",
    "plan_price": "20000.00",
    "cost": 5223899,
    "show_calculated_cost": true,
    "ratings_score": null,
    "minimum_plot_size": "30x60"
}
*/
